'use client';
import React from 'react';

import { FaCloudsmith } from 'react-icons/fa6';

const HeaderPageLink = () => {
  const handleClick = (url: string) => {
    window.location.href = url;
  };

  return (
    <>
      <div className="row row-cols-1 row-cols-xl-3 g-3 g-xl-4">
        <div className="col">
          <div className="megamenu__card">
            <h6 className="megamenu__header">Shop Layouts</h6>
            <ul className="megamenu__item-list">
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/flash-sale')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Flash Sale
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/shop')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Shop Left Sidebar
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/shop/shop-right')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Shop Right Sidebar
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/wishlist')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Wishlist
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/cart')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Cart
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/checkout')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Checkout
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col">
          <div className="megamenu__card">
            <h6 className="megamenu__header">Other Pages</h6>
            <ul className="megamenu__item-list">
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/faq')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  FAQ
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/invoice')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Invoice
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/login')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Login
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/forgot-password')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Reset Password
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/order-tracking')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Order Tracking
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/not-found')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  404
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col">
          <div className="megamenu__card">
            <h6 className="megamenu__header">Blogs Types</h6>
            <ul className="megamenu__item-list">
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/blogs')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Blogs
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/blogs/blog-right')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Blog Right Sidebar
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/blogs/blog-left')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Blog Left Sidebar
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick('/blogs/blog-details')}
                >
                  <span>
                    <FaCloudsmith />
                  </span>
                  Blog Details
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderPageLink;
